// removed by extract-text-webpack-plugin
module.exports = {"footer-links":"FooterLinks__footer-links","footerLinks":"FooterLinks__footer-links","link-columns":"FooterLinks__link-columns","linkColumns":"FooterLinks__link-columns"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/FooterLinks.mobile.css
// module id = 1384
// module chunks = 8